import React from 'react';

export function ToggleSwitch({checked, onChange}: {checked: boolean, onChange: (checked: boolean) => void}) {
  return (
    <label className="tw-relative tw-inline-flex tw-cursor-pointer tw-items-center">
      <input id="switch-component" checked={checked} type="checkbox" className="tw-peer tw-sr-only" onChange={e => onChange(e.target.checked)} />
      <label htmlFor="switch-component" className="tw-hidden"></label>
      <div className="tw-peer tw-h-5 tw-w-9 tw-rounded-full tw-border tw-bg-slate-200 after:tw-absolute after:tw-left-[2px] after:tw-top-0.5 after:tw-h-4 after:tw-w-4 after:tw-rounded-full after:tw-border after:tw-border-gray-300 after:tw-bg-white after:tw-transition-all after:tw-content-[''] peer-checked:tw-bg-blue-light peer-checked:after:tw-translate-x-full peer-checked:after:tw-border-white peer-focus:tw-ring-green-300"></div>
    </label>
  )
}